import { Box } from '@mui/joy';
import { useDraggable } from '@dnd-kit/core';
import { useDeleteMealPlanEntryMutation } from '../api';
import { MealEntry } from '@/features/meals/components/MealEntry';

// entry is the raw meal-plan-entry record; kind + item are the resolved
// recipe/ingredient/event this slot points at (see resolveMealPlanEntryItem).
// The drag payload carries every field the entry might need so a move can be
// applied without re-fetching -- see useDragAndDrop.jsx.
export function DraggableMealEntry({ entry, kind, item, isEditable, householdId, originalDate, originalMealType, variant }) {
  const { attributes, listeners, setNodeRef, active } = useDraggable({
    id: `meal-${entry.id}`,
    disabled: !isEditable,
    data: {
      entryId: entry.id,
      entryType: entry.entry_type,
      recipeId: entry.recipe_id,
      ingredient: entry.ingredient,
      eventId: entry.event_id,
      originalDate,
      originalMealType,
    },
  });

  const currentIsBeingDragged = active?.id === `meal-${entry.id}`;
  const [deleteMutation] = useDeleteMealPlanEntryMutation();

  const handleDelete = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      await deleteMutation({ householdId, id: entry.id });
    } catch (error) {
      console.error('Failed to remove entry from meal plan:', error);
    }
  };

  return (
    <Box
      ref={setNodeRef}
      {...(isEditable ? { ...attributes, ...listeners } : {})}
      sx={{ opacity: currentIsBeingDragged ? 0 : 1 }}
    >
      <MealEntry
        kind={kind}
        item={item}
        entry={entry}
        nutrition={item.personalizedNutrition}
        onDelete={isEditable ? handleDelete : null}
        variant={variant}
      />
    </Box>
  );
}
